<template>
  <div class="sasl-page">
    <div class="sasl-header">
      <h1 class="sasl-title">時段管理</h1>
      <div class="sasl-view-tabs">
        <button :class="['sasl-view-tab', viewMode === 'card'     && 'sasl-view-tab--on']" @click="setView('card')"><span v-if="obGuideStep === 1" class="sasl-ob-hand">👆 </span>卡片</button>
        <button :class="['sasl-view-tab', viewMode === 'table'    && 'sasl-view-tab--on']" @click="setView('table')"><span v-if="obGuideStep === 2" class="sasl-ob-hand">👆 </span>表格</button>
        <button :class="['sasl-view-tab', viewMode === 'calendar' && 'sasl-view-tab--on']" @click="setView('calendar')">行事曆</button>
      </div>
    </div>

    <!-- 新手引導橫幅（步驟 4） -->
    <div v-if="showObBanner" class="sasl-ob-banner">
      <div class="sasl-ob-banner__steps">
        <span class="sasl-ob-banner__step">① 店家資料 ✓</span>
        <span class="sasl-ob-banner__sep">›</span>
        <span class="sasl-ob-banner__step">② 營業時間 ✓</span>
        <span class="sasl-ob-banner__sep">›</span>
        <span class="sasl-ob-banner__step">③ 服務設定 ✓</span>
        <span class="sasl-ob-banner__sep">›</span>
        <span class="sasl-ob-banner__step sasl-ob-banner__step--active">④ 新增時段</span>
      </div>
      <p class="sasl-ob-banner__hint">🎉 最後一步！點右上角「＋ 新增時段」建立可預約的時段</p>
    </div>

    <!-- 引導：探索時段管理各種檢視（步驟 1 = 看行事曆→點卡片，步驟 2 = 點表格）-->
    <div v-if="obGuideStep === 1 || obGuideStep === 2" class="sasl-ob-guide">
      <span v-if="obGuideStep === 1">
        🎉 時段建立完成！這是<strong>行事曆</strong>檢視，點上方「<strong>卡片</strong>」試試看 👆
      </span>
      <span v-else>
        現在是<strong>卡片</strong>檢視，再點「<strong>表格</strong>」看看 👆
      </span>
    </div>
    <div v-if="obGuideStep === 3" class="sasl-ob-guide sasl-ob-guide--done">
      <span>✅ 三種檢視都看過了！接著來看預約管理</span>
      <router-link :to="{ name: 'StoreAdminReservations', query: { onboard: '5' } }" class="sasl-ob-guide__btn">
        下一步 → 預約管理
      </router-link>
    </div>

    <!-- 月份導覽列（卡片/表格模式） -->
    <div v-if="viewMode !== 'calendar'" class="sasl-month-nav">
      <button class="sasl-month-btn" @click="prevMonth">&#8592;</button>
      <span class="sasl-month-label">{{ currentYearMonth }}</span>
      <button class="sasl-month-btn" @click="nextMonth">&#8594;</button>
    </div>

    <!-- 日期快捷列（卡片/表格模式） -->
    <div v-if="viewMode !== 'calendar'" class="sasl-day-strip" ref="dayStripRef">
      <button
        v-for="day in daysInMonth"
        :key="day.date"
        class="sasl-day-chip"
        :class="{
          'sasl-day-chip--selected': selectedDate === day.date,
          'sasl-day-chip--today':    day.date === todayTW,
          'sasl-day-chip--past':     day.date < todayTW,
        }"
        @click="selectDate(day.date)"
      >
        <span class="sasl-day-chip__dow">{{ day.dow }}</span>
        <span class="sasl-day-chip__num">{{ day.num }}</span>
      </button>
    </div>

    <!-- 行事曆導覽列 -->
    <div v-if="viewMode === 'calendar'" class="sasl-cal-nav">
      <div class="sasl-cal-nav-left">
        <button class="sasl-btn sasl-btn--ghost sasl-btn--sm" @click="calPrev">‹</button>
        <span class="sasl-cal-title">{{ calYear }} 年 {{ calMonthNum }} 月</span>
        <button class="sasl-btn sasl-btn--ghost sasl-btn--sm" @click="calNext">›</button>
        <button class="sasl-btn sasl-btn--ghost sasl-btn--sm" @click="calToday">今天</button>
      </div>
      <div class="sasl-cal-nav-right">
        <div v-if="teacherList.length" class="sasl-select-wrap">
          <select v-model="filterTeacher" class="sasl-input sasl-select">
            <option value="">全部</option>
            <option v-for="t in teacherList" :key="t" :value="t">{{ t }}</option>
          </select>
          <span class="sasl-select-arrow">▾</span>
        </div>
        <div class="sasl-select-wrap">
          <select v-model="filterStatus" class="sasl-input sasl-select">
            <option value="">全部狀態</option>
            <option value="available">可預約</option>
            <option value="full">已額滿</option>
          </select>
          <span class="sasl-select-arrow">▾</span>
        </div>
      </div>
    </div>

    <!-- 老師 + 狀態篩選列（卡片/表格模式） -->
    <div v-if="viewMode !== 'calendar'" class="sasl-filter-bar">
      <div v-if="teacherList.length" class="sasl-filter-item">
        <label class="sasl-filter-label">老師</label>
        <div class="sasl-select-wrap">
          <select v-model="filterTeacher" class="sasl-input sasl-select">
            <option value="">全部</option>
            <option v-for="t in teacherList" :key="t" :value="t">{{ t }}</option>
          </select>
          <span class="sasl-select-arrow">▾</span>
        </div>
      </div>
      <div class="sasl-filter-item">
        <label class="sasl-filter-label">狀態</label>
        <div class="sasl-select-wrap">
          <select v-model="filterStatus" class="sasl-input sasl-select">
            <option value="">全部狀態</option>
            <option value="available">可預約</option>
            <option value="full">已額滿</option>
          </select>
          <span class="sasl-select-arrow">▾</span>
        </div>
      </div>
    </div>

    <!-- ───── 行事曆模式 ───── -->
    <template v-if="viewMode === 'calendar'">
      <div v-if="calLoading" class="sasl-state"><span class="sasl-spinner" /><p>載入中…</p></div>
      <div v-else class="sasl-cal-grid-wrap"><div class="sasl-cal-grid">
        <div class="sasl-cal-weekday" v-for="d in CAL_WEEK_DAYS" :key="d">{{ d }}</div>
        <div class="sasl-cal-day sasl-cal-day--blank" v-for="i in calFirstWeekday" :key="'b'+i"></div>
        <div
          v-for="day in calDaysInMonth"
          :key="day"
          class="sasl-cal-day"
          :class="{ 'sasl-cal-day--today': calIsToday(day), 'sasl-cal-day--has': calSlotsForDay(day).length > 0 }"
          @click="openCalDay(day)"
          style="cursor:pointer"
        >
          <div class="sasl-cal-day-num" @click.stop="openCalDay(day)">{{ day }}</div>
          <template v-if="calNotes[calDateStr(day)]">
            <div
              v-for="(note, tname) in calNotes[calDateStr(day)]"
              :key="tname"
              v-show="!filterTeacher || filterTeacher === tname || (tname === '' && note.startsWith(filterTeacher))"
              class="sasl-cal-day-note"
              @click.stop="openCalDay(day)"
            >{{ note }}</div>
          </template>
          <div class="sasl-cal-events">
            <div
              v-for="s in calSlotsForDay(day).slice(0, 4)"
              :key="s.id"
              class="sasl-cal-chip"
              :class="calChipClass(s)"
              @click="openCalDay(day)"
            >
              <span class="sasl-cal-chip-time">{{ fmtTime(s.start_time) }}</span>
              <span v-if="s.teacher_name" class="sasl-cal-chip-teacher">{{ s.teacher_name.slice(0,2) }}</span>
            </div>
            <div
              v-if="calSlotsForDay(day).length > 4"
              class="sasl-cal-more"
              @click="openCalDay(day)"
            >
              +{{ calSlotsForDay(day).length - 4 }} 筆
            </div>
          </div>
        </div>
      </div></div>
    </template>

    <!-- 行事曆 day popup -->
    <teleport to="body">
      <transition name="fade">
        <div v-if="calDayPopup !== null" class="sasl-modal-overlay" @click.self="calDayPopup = null">
          <div class="sasl-modal sasl-modal--sm">
            <div class="sasl-modal__header">
              <h2 class="sasl-modal__title">{{ calDateStr(calDayPopup) }} 時段</h2>
              <button class="sasl-modal__close" @click="calDayPopup = null">✕</button>
            </div>
            <div class="sasl-modal__body sasl-cal-day-list">
              <!-- 老師選擇（popup 內，置於最上方） -->
              <div v-if="teacherList.length" class="sasl-popup-teacher-row">
                <label class="sasl-popup-teacher-label">老師</label>
                <select v-model="filterTeacher" class="sasl-input sasl-input--sm">
                  <option value="">全部</option>
                  <option v-for="t in teacherList" :key="t" :value="t">{{ t }}</option>
                </select>
              </div>
              <!-- 備註編輯區（需選老師才可輸入） -->
              <div class="sasl-popup-note">
                <p class="sasl-popup-note__label">📌 當日備註</p>
                <!-- 已有備註：顯示文字 + 修改/清除（需選老師才能修改） -->
                <div v-if="popupNoteSavedText && !popupNoteEditing" class="sasl-popup-note__row">
                  <span class="sasl-popup-note__text">{{ popupNoteSavedText }}</span>
                  <button class="sasl-btn sasl-btn--sm sasl-btn--secondary" :disabled="!filterTeacher" @click="popupNoteEditing = true">修改</button>
                  <button class="sasl-btn sasl-btn--sm sasl-btn--danger-outline" :disabled="!filterTeacher" @click="clearPopupNote">清除</button>
                </div>
                <!-- 無備註或編輯中：未選老師時顯示提示 -->
                <div v-else-if="!filterTeacher" class="sasl-popup-note__hint">
                  請先選擇老師再輸入備註
                </div>
                <div v-else class="sasl-popup-note__row">
                  <input v-model="popupNote" type="text" maxlength="100"
                    placeholder="例：出國、培訓、公休…"
                    class="sasl-input sasl-popup-note__input"
                    @keyup.enter="savePopupNote" />
                  <button class="sasl-btn sasl-btn--primary sasl-btn--sm" :disabled="popupNoteSaving" @click="savePopupNote">
                    {{ popupNoteSaving ? '儲存中…' : '儲存' }}
                  </button>
                  <button v-if="popupNoteEditing" class="sasl-btn sasl-btn--secondary sasl-btn--sm" @click="popupNoteEditing = false">取消</button>
                </div>
                <p v-if="popupNoteSaved" class="sasl-popup-note__ok">✅ 已儲存</p>
              </div>
              <!-- 設為全天休假 -->
              <div class="sasl-popup-vacation">
                <button
                  class="sasl-btn sasl-btn--danger-outline sasl-btn--sm"
                  :disabled="!filterTeacher"
                  :class="{ 'sasl-btn--disabled-hint': !filterTeacher }"
                  @click="setPopupVacation"
                >
                  🏖️ 設為全天休假{{ filterTeacher ? `（${filterTeacher}）` : '' }}
                </button>
                <span v-if="!filterTeacher" class="sasl-holiday-hint">⚠ 請先選擇老師</span>
              </div>

              <div v-if="calSlotsForDay(calDayPopup).length === 0" class="sasl-state sasl-state--hint" style="padding:16px 0">
                <p>此日期無符合時段</p>
              </div>
              <div
                v-for="s in calSlotsForDay(calDayPopup)"
                :key="s.id"
                class="sasl-cal-day-item"
              >
                <span class="sasl-cal-day-item__time">{{ fmtTime(s.start_time) }}–{{ s.actual_end_time || fmtTime(s.end_time) }}</span>
                <span v-if="s.teacher_name" class="sasl-cal-day-item__teacher">{{ s.teacher_name }}</span>
                <span class="sasl-slot-tag" :class="slotTagClass(s)">{{ slotTagLabel(s) }}</span>
                <span class="sasl-cal-day-item__cap">{{ s.booked_count }}/{{ s.capacity }}</span>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </teleport>

    <!-- 選定日期 時段列表（卡片/表格模式） -->
    <div v-if="viewMode !== 'calendar'" class="sasl-slots-area">
      <div class="sasl-slots-date-row">
        <p class="sasl-slots-date">
          {{ selectedDate || '請選擇日期' }}
          <span v-if="selectedDate === todayTW" class="sasl-today-tag">今天</span>
        </p>
      </div>

      <!-- 當日休假備註橫幅 -->
      <div v-if="selectedDate && dayNoteSavedText" class="sasl-day-note-banner">
        📌 {{ dayNoteSavedText }}
      </div>

      <!-- 載入中 -->
      <div v-if="slotsLoading" class="sasl-state">
        <span class="sasl-spinner" />
        <p>載入時段…</p>
      </div>

      <!-- 載入錯誤 -->
      <div v-else-if="slotsError" class="sasl-state sasl-state--error">
        <p>{{ slotsError }}</p>
        <button class="sasl-btn sasl-btn--secondary" @click="loadSlots">重新載入</button>
      </div>

      <!-- 未選日期 -->
      <div v-else-if="!selectedDate" class="sasl-state sasl-state--hint">
        <p>請從上方選擇日期以檢視時段</p>
      </div>

      <!-- 空（全部老師都沒有時段） -->
      <div v-else-if="slots.length === 0" class="sasl-state sasl-state--hint">
        <p>此日期尚無時段</p>

        <!-- 無老師篩選時：先選老師 -->
        <div v-if="!filterTeacher && teacherList.length" class="sasl-teacher-select">
          <p class="sasl-teacher-select__label">選擇老師以設定當日備註</p>
          <div class="sasl-teacher-select__row">
            <select class="sasl-input" @change="e => filterTeacher = e.target.value">
              <option value="">-- 選擇老師 --</option>
              <option v-for="t in teacherList" :key="t" :value="t">{{ t }}</option>
            </select>
          </div>
        </div>

        <!-- 備註輸入區（需選老師後才顯示） -->
        <div v-if="filterTeacher" class="sasl-day-note">
          <p class="sasl-day-note__label">📌 當日備註（客人可見）</p>

          <!-- 已有備註：顯示目前內容 -->
          <div v-if="dayNoteSavedText" class="sasl-day-note__current">
            <span class="sasl-day-note__current-text">{{ dayNoteSavedText }}</span>
            <button class="sasl-btn sasl-btn--sm sasl-btn--secondary" @click="dayNoteEditing = true">修改</button>
            <button class="sasl-btn sasl-btn--sm sasl-btn--danger-outline" @click="clearDayNote">清除</button>
          </div>

          <!-- 無備註 or 編輯中 -->
          <div v-if="!dayNoteSavedText || dayNoteEditing" class="sasl-day-note__row">
            <input
              v-model="dayNote"
              type="text"
              maxlength="100"
              placeholder="例：出國、培訓、公休…"
              class="sasl-input sasl-day-note__input"
              @keyup.enter="saveDayNote"
            />
            <button class="sasl-btn sasl-btn--primary sasl-btn--sm" :disabled="dayNoteSaving" @click="saveDayNote">
              <span v-if="dayNoteSaving" class="sasl-spinner sasl-spinner--sm sasl-spinner--white" />
              {{ dayNoteSaving ? '儲存中…' : '儲存' }}
            </button>
            <button v-if="dayNoteEditing" class="sasl-btn sasl-btn--secondary sasl-btn--sm" @click="dayNoteEditing = false">取消</button>
          </div>
          <p v-if="dayNoteSaved" class="sasl-day-note__ok">✅ 已儲存</p>
        </div>
      </div>

      <!-- 全天休假按鈕（有時段就顯示；有篩選老師時只算該老師的時段） -->
      <div v-else class="sasl-holiday-bar">
        <div class="sasl-holiday-btn-wrap">
          <button
            class="sasl-btn sasl-btn--danger-outline"
            :class="{ 'sasl-btn--disabled-hint': !filterTeacher }"
            :disabled="holidaying"
            @click="markHoliday"
          >
            <span v-if="holidaying" class="sasl-spinner sasl-spinner--sm" />
            全天休假（清除 {{ (filterTeacher ? displaySlots : slots).filter(s => s.booked_count === 0).length }} 個時段）
          </button>
          <span v-if="!filterTeacher" class="sasl-holiday-hint">⚠ 請先選擇老師</span>
        </div>
      </div>

      <!-- 篩選後無時段提示 + 當日備註輸入 -->
      <div v-if="filterTeacher && slots.length > 0 && displaySlots.length === 0" class="sasl-state sasl-state--hint">
        <p>「{{ filterTeacher }}」在此日期尚無時段</p>

        <!-- 備註輸入區 -->
        <div class="sasl-day-note" style="width:100%">
          <p class="sasl-day-note__label">📌 當日備註（客人可見）</p>

          <div v-if="dayNoteSavedText" class="sasl-day-note__current">
            <span class="sasl-day-note__current-text">{{ dayNoteSavedText }}</span>
            <button class="sasl-btn sasl-btn--sm sasl-btn--secondary" @click="dayNoteEditing = true">修改</button>
            <button class="sasl-btn sasl-btn--sm sasl-btn--danger-outline" @click="clearDayNote">清除</button>
          </div>

          <div v-if="!dayNoteSavedText || dayNoteEditing" class="sasl-day-note__row">
            <input
              v-model="dayNote"
              type="text"
              maxlength="100"
              placeholder="例：出國、培訓、公休…"
              class="sasl-input sasl-day-note__input"
              @keyup.enter="saveDayNote"
            />
            <button class="sasl-btn sasl-btn--primary sasl-btn--sm" :disabled="dayNoteSaving" @click="saveDayNote">
              <span v-if="dayNoteSaving" class="sasl-spinner sasl-spinner--sm sasl-spinner--white" />
              {{ dayNoteSaving ? '儲存中…' : '儲存' }}
            </button>
            <button v-if="dayNoteEditing" class="sasl-btn sasl-btn--secondary sasl-btn--sm" @click="dayNoteEditing = false">取消</button>
          </div>
          <p v-if="dayNoteSaved" class="sasl-day-note__ok">✅ 已儲存</p>
        </div>
      </div>

      <!-- 時段列表：表格模式 -->
      <div v-if="displaySlots.length > 0 && viewMode === 'table'" class="sasl-table-wrap">
        <table class="sasl-table">
          <thead>
            <tr>
              <th>時間</th>
              <th v-if="!filterTeacher">老師</th>
              <th>狀態</th>
              <th>顧客</th>
              <th>已/總</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="slot in displaySlots" :key="slot.id">
              <tr :class="slot.booked_count >= slot.capacity ? 'sasl-tr--full' : ''">
                <td class="sasl-td-time" style="white-space:nowrap">
                  {{ fmtTime(slot.start_time) }} –
                  {{ slot.reservation ? fmtTime(slot.reservation.actual_end_time) : fmtTime(slot.end_time) }}
                </td>
                <td v-if="!filterTeacher">{{ slot.teacher_name || '—' }}</td>
                <td>
                  <span class="sasl-slot-tag" :class="slotTagClass(slot)">{{ slotTagLabel(slot) }}</span>
                </td>
                <td>
                  <template v-if="slot.reservation?.is_continuation">
                    <span style="font-size:0.78rem;color:#aaa">佔用中</span>
                  </template>
                  <template v-else-if="slot.reservations?.length">
                    <div v-for="(res, idx) in slot.reservations" :key="res.id || idx"
                         :style="idx > 0 ? 'margin-top:6px;padding-top:6px;border-top:1px solid #f0f0f0' : ''">
                      <div style="font-size:0.85rem;font-weight:500">{{ res.customer_name }}</div>
                      <div style="font-size:0.78rem;color:#aaa">{{ res.customer_phone }}</div>
                    </div>
                  </template>
                  <template v-else>—</template>
                </td>
                <td style="white-space:nowrap">{{ slot.booked_count }} / {{ slot.capacity }}</td>
                <td>
                  <div class="sasl-table-actions">
                    <button class="sasl-btn sasl-btn--sm sasl-btn--secondary" @click="startEditCap(slot)">修改人數</button>
                    <button
                      class="sasl-btn sasl-btn--sm sasl-btn--danger"
                      :disabled="deleteLoading[slot.id]"
                      @click="deleteSlot(slot)"
                    >
                      <span v-if="deleteLoading[slot.id]" class="sasl-spinner sasl-spinner--sm sasl-spinner--white" />
                      刪除
                    </button>
                  </div>
                </td>
              </tr>
              <!-- 修改人數展開列（表格模式） -->
              <tr v-if="editCapSlot === slot.id" class="sasl-cap-edit-row-tr">
                <td :colspan="filterTeacher ? 5 : 6" class="sasl-cap-edit-td">
                  <div v-if="Number(editCapVal) > slot.capacity" class="sasl-cap-warn">
                    ⚠️ 人數增加後，多位客人可同時預約此時段。請確認您有足夠的<b>美容床</b>可同時服務 {{ editCapVal }} 位顧客，以確保服務品質。
                  </div>
                  <div class="sasl-cap-edit-row">
                    <label class="sasl-cap-edit-label">可預約人數</label>
                    <input v-model.number="editCapVal" type="number" min="1" max="20" class="sasl-cap-input" />
                    <button class="sasl-btn sasl-btn--sm sasl-btn--primary" :disabled="editCapLoading" @click="saveCapacity(slot)">
                      <span v-if="editCapLoading" class="sasl-spinner sasl-spinner--sm sasl-spinner--white" />
                      {{ editCapLoading ? '儲存中…' : '確認' }}
                    </button>
                    <button class="sasl-btn sasl-btn--sm sasl-btn--secondary" @click="editCapSlot = null">取消</button>
                  </div>
                  <p v-if="editCapError" class="sasl-inline-error">{{ editCapError }}</p>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>

      <!-- 時段列表：卡片模式 -->
      <div v-if="displaySlots.length > 0 && viewMode === 'card'" class="sasl-slot-list">
        <div
          v-for="slot in displaySlots"
          :key="slot.id"
          class="sasl-slot-card"
          :class="slotCardClass(slot)"
        >
          <!-- 延伸時段：縮成單行灰字，只保留刪除鈕 -->
          <template v-if="slot.reservation?.is_continuation">
            <div class="sasl-slot-card__continuation-compact">
              佔用中（{{ fmtTime(slot.reservation.origin_start_time) }} 開始的 {{ slot.reservation.duration_minutes }} 分鐘預約）
            </div>
            <div class="sasl-slot-card__actions">
              <button
                class="sasl-btn sasl-btn--sm sasl-btn--danger"
                :disabled="deleteLoading[slot.id]"
                @click="deleteSlot(slot)"
              >
                <span v-if="deleteLoading[slot.id]" class="sasl-spinner sasl-spinner--sm sasl-spinner--white" />
                刪除
              </button>
            </div>
            <p v-if="deleteError[slot.id]" class="sasl-inline-error">{{ deleteError[slot.id] }}</p>
          </template>

          <!-- 一般時段（起始 or 無預約）-->
          <template v-else>
            <!-- 時間 + 狀態標籤 -->
            <div class="sasl-slot-card__top">
              <span class="sasl-slot-card__time">
                {{ fmtTime(slot.start_time) }} –
                {{ slot.reservation ? fmtTime(slot.reservation.actual_end_time) : fmtTime(slot.end_time) }}
              </span>
              <span class="sasl-slot-tag" :class="slotTagClass(slot)">
                {{ slotTagLabel(slot) }}
              </span>
            </div>

            <!-- 老師名稱 -->
            <div v-if="slot.teacher_name" class="sasl-slot-card__teacher">
              {{ slot.teacher_name }}<template v-if="slot.service_item"> · {{ slot.service_item }}</template>
            </div>

            <!-- 預約顧客資訊（支援多人同時段） -->
            <div v-if="slot.reservations?.length" class="sasl-slot-card__reservations">
              <div
                v-for="(res, idx) in slot.reservations"
                :key="res.id || idx"
                class="sasl-slot-card__reservation"
                :class="{ 'sasl-res-item--border': idx > 0 }"
              >
                <span class="sasl-res-customer">👤 {{ res.customer_name }}</span>
                <span class="sasl-res-via">{{ res.line_user_id ? 'LINE預約' : '信箱預約' }}</span>
                <span class="sasl-res-phone">📞 {{ res.customer_phone }}</span>
                <span class="sasl-res-meta">{{ res.service_name }}・{{ res.duration_minutes }} 分鐘</span>
                <span v-if="res.line_user_id" class="sasl-res-uid">LINE ID：{{ res.line_user_id }}</span>
              </div>
            </div>

            <!-- 容量資訊 -->
            <div class="sasl-slot-card__cap">
              <span>已預約 {{ slot.booked_count }} / {{ slot.capacity }} 人</span>
              <div class="sasl-cap-bar">
                <div
                  class="sasl-cap-bar__fill"
                  :style="{ width: capPercent(slot) + '%' }"
                  :class="{ 'sasl-cap-bar__fill--full': slot.booked_count >= slot.capacity }"
                />
              </div>
            </div>

            <!-- 操作按鈕 -->
            <div class="sasl-slot-card__actions">
              <button
                class="sasl-btn sasl-btn--sm sasl-btn--secondary"
                @click="startEditCap(slot)"
              >修改人數</button>
              <button
                class="sasl-btn sasl-btn--sm sasl-btn--danger"
                :disabled="deleteLoading[slot.id]"
                @click="deleteSlot(slot)"
              >
                <span v-if="deleteLoading[slot.id]" class="sasl-spinner sasl-spinner--sm sasl-spinner--white" />
                刪除
              </button>
            </div>

            <!-- 修改人數 inline -->
            <div v-if="editCapSlot === slot.id" class="sasl-cap-edit">
              <div v-if="Number(editCapVal) > slot.capacity" class="sasl-cap-warn">
                ⚠️ 人數增加後，多位客人可同時預約此時段。請確認您有足夠的<b>美容床</b>可同時服務 {{ editCapVal }} 位顧客，以確保服務品質。
              </div>
              <div class="sasl-cap-edit-row">
                <label class="sasl-cap-edit-label">可預約人數</label>
                <input v-model.number="editCapVal" type="number" min="1" max="20" class="sasl-cap-input" />
                <button class="sasl-btn sasl-btn--sm sasl-btn--primary" :disabled="editCapLoading" @click="saveCapacity(slot)">
                  <span v-if="editCapLoading" class="sasl-spinner sasl-spinner--sm sasl-spinner--white" />
                  {{ editCapLoading ? '儲存中…' : '確認' }}
                </button>
                <button class="sasl-btn sasl-btn--sm sasl-btn--secondary" @click="editCapSlot = null">取消</button>
              </div>
              <p v-if="editCapError" class="sasl-inline-error">{{ editCapError }}</p>
            </div>

            <!-- 逐筆操作錯誤 -->
            <p v-if="deleteError[slot.id]" class="sasl-inline-error">
              {{ deleteError[slot.id] }}
            </p>
          </template>
        </div>
      </div>
    </div>

    <!-- ── 全天休假 Modal ────────────────────────────── -->
    <teleport to="body">
      <div v-if="showHolidayModal" class="sasl-modal-overlay" @click.self="showHolidayModal = false">
        <div class="sasl-modal sasl-modal--sm" role="dialog">
          <div class="sasl-modal__header">
            <h2 class="sasl-modal__title">全天休假</h2>
            <button class="sasl-modal__close" @click="showHolidayModal = false">✕</button>
          </div>
          <div class="sasl-modal__body">
            <!-- 已有預約的警告 -->
            <div v-if="bookedSlotsOnDay.length > 0" class="sasl-holiday-warning">
              <p class="sasl-holiday-warning__title">⚠️ 以下時段已有顧客預約，清除後將影響預約：</p>
              <ul class="sasl-holiday-warning__list">
                <li v-for="s in bookedSlotsOnDay" :key="s.id">
                  {{ fmtTime(s.start_time) }}–{{ fmtTime(s.end_time) }}
                  <span class="sasl-holiday-warning__count">（{{ s.booked_count }} 筆預約）</span>
                  <span v-if="s.teacher_name" class="sasl-holiday-warning__teacher">· {{ s.teacher_name }}</span>
                </li>
              </ul>
              <p class="sasl-holiday-warning__hint">請確認已聯絡相關顧客，再執行休假。</p>
            </div>

            <p class="sasl-modal__desc">
              將清除 <strong>{{ (filterTeacher ? displaySlots : slots).filter(s => s.booked_count === 0).length }}</strong> 個空白時段。<br/>
              可填寫休假原因，客人預約時將看到此說明。
            </p>
            <div class="sasl-field">
              <label>休假原因（選填）</label>
              <input
                v-model="holidayReason"
                type="text"
                maxlength="100"
                placeholder="例：出國、培訓、公休…"
                class="sasl-input"
                @keyup.enter="confirmHoliday"
              />
            </div>
          </div>
          <div class="sasl-modal__footer">
            <button class="sasl-btn sasl-btn--secondary" @click="showHolidayModal = false">取消</button>
            <button class="sasl-btn sasl-btn--danger" :disabled="holidaying" @click="confirmHoliday">
              <span v-if="holidaying" class="sasl-spinner sasl-spinner--sm sasl-spinner--white" />
              {{ holidaying ? '清除中…' : bookedSlotsOnDay.length > 0 ? '⚠ 已知悉，強制休假' : '確認休假' }}
            </button>
          </div>
        </div>
      </div>
    </teleport>

    <!-- ── 批次建立時段 Modal ──────────────────────── -->
    <teleport to="body">
      <div v-if="showBatch" class="sasl-modal-overlay" @click.self="closeBatch">
        <div class="sasl-modal" role="dialog" aria-label="批次建立時段">
          <div class="sasl-modal__header">
            <h2 class="sasl-modal__title">新增時段{{ filterTeacher ? ` — ${filterTeacher}` : '' }}</h2>
            <button class="sasl-modal__close" @click="closeBatch" aria-label="關閉">✕</button>
          </div>

          <div class="sasl-modal__body">
            <p class="sasl-modal__desc">
              設定日期範圍與每日時段，系統會自動建立（已存在的時段略過，不重複建立）。
            </p>

            <!-- 目前日期已有時段時提醒 -->
            <div v-if="slots.length > 0 && selectedDate >= batchForm.start_date && selectedDate <= batchForm.end_date"
                 class="sasl-batch-exist-warn">
              ⚠ {{ selectedDate }} 已有 {{ filterTeacher ? displaySlots.length : slots.length }} 個時段，重複的將自動略過
            </div>

            <!-- 日期範圍 -->
            <div class="sasl-field-row">
              <div class="sasl-field">
                <label for="b-start">開始日期 <span class="sasl-required">*</span></label>
                <input
                  id="b-start"
                  v-model="batchForm.start_date"
                  type="date"
                  :min="todayTW"
                  class="sasl-input"
                  :class="{ 'sasl-input--error': batchErrors.start_date }"
                />
                <p v-if="batchErrors.start_date" class="sasl-field-error">{{ batchErrors.start_date }}</p>
              </div>
              <div class="sasl-field">
                <label for="b-end">結束日期 <span class="sasl-required">*</span></label>
                <input
                  id="b-end"
                  v-model="batchForm.end_date"
                  type="date"
                  :min="batchForm.start_date || todayTW"
                  class="sasl-input"
                  :class="{ 'sasl-input--error': batchErrors.end_date }"
                />
                <p v-if="batchErrors.end_date" class="sasl-field-error">{{ batchErrors.end_date }}</p>
              </div>
            </div>

            <!-- 每日時段設定 -->
            <div class="sasl-field">
              <label>每日時段設定 <span class="sasl-required">*</span></label>
              <p v-if="batchErrors.slots" class="sasl-field-error">{{ batchErrors.slots }}</p>

              <div class="sasl-batch-schedule">
                <div class="sasl-batch-row">
                  <!-- 開始時間 -->
                  <div class="sasl-batch-col">
                    <label>開始時間</label>
                    <input v-model="batchForm.day_start" type="time" class="sasl-input" />
                  </div>
                  <!-- 結束時間 + 隔天 -->
                  <div class="sasl-batch-col">
                    <label>結束時間</label>
                    <div class="sasl-time-next">
                      <input v-model="batchForm.day_end" type="time" class="sasl-input" />
                      <label class="sasl-checkbox-next">
                        <input type="checkbox" v-model="batchForm.next_day" />
                        <span>隔天</span>
                      </label>
                    </div>
                  </div>
                  <!-- 間隔 -->
                  <div class="sasl-batch-col sasl-batch-col--sm">
                    <label>間隔（分鐘）</label>
                    <select v-model.number="batchForm.interval" class="sasl-input">
                      <option :value="30">30</option>
                      <option :value="60">60</option>
                      <option :value="90">90</option>
                      <option :value="120">120</option>
                    </select>
                  </div>
                </div>
                <p class="sasl-batch-preview">
                  預覽：{{ batchPreview }}
                </p>
              </div>

              <!-- 老師由服務管理帶入，此處不需手動填寫 -->
              <p v-if="filterTeacher" class="sasl-batch-teacher-hint">
                🧑‍💼 此時段將建立給：<strong>{{ filterTeacher }}</strong>
              </p>
            </div>

            <!-- API 錯誤 -->
            <p v-if="batchError" class="sasl-api-error">{{ batchError }}</p>

            <!-- 衝突提示 -->
            <div v-if="batchConflicts.length" class="sasl-conflict-box">
              <p class="sasl-conflict-title">⚠ 以下 {{ batchConflicts.length }} 個時段已存在，無法重複新增：</p>
              <ul class="sasl-conflict-list">
                <li v-for="(c, i) in batchConflicts" :key="i">
                  {{ c.date }} &nbsp;
                  {{ c.start_time.slice(0,5) }} – {{ c.end_time.slice(0,5) }}
                  <span v-if="c.teacher_name" class="sasl-conflict-cap">（{{ c.teacher_name }}）</span>
                </li>
              </ul>
              <p class="sasl-conflict-hint">
                💡 若想開放更多人預約同一時段，請找到該時段點「編輯」，將可預約人數改為 2、3 或更多。<br>
                若要重新建立，請先刪除現有時段後再批次新增。
              </p>
            </div>

            <!-- 批次完成提示 -->
            <p v-if="batchResult" class="sasl-api-success">
              建立完成，共新增 {{ batchResult.inserted }} 筆時段。
            </p>
          </div>

          <div class="sasl-modal__footer">
            <button class="sasl-btn sasl-btn--secondary" @click="closeBatch">關閉</button>
            <button
              class="sasl-btn sasl-btn--primary"
              :disabled="batchSubmitting"
              @click="submitBatch"
            >
              <span v-if="batchSubmitting" class="sasl-spinner sasl-spinner--sm sasl-spinner--white" />
              {{ batchSubmitting ? '建立中…' : '批次建立' }}
            </button>
          </div>
        </div>
      </div>
    </teleport>
  </div>
</template>

<script setup>
import { ref, computed, watch, nextTick } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStoreAdminStore } from '@/store/storeAdminStore'

const router          = useRouter()
const route           = useRoute()
const storeAdminStore = useStoreAdminStore()

// ── 顯示模式 ──────────────────────────────────────────
const viewMode = ref('calendar')

function setView(mode) {
  viewMode.value = mode
  if (obGuideStep.value === 1 && mode === 'card')   obGuideStep.value = 2
  else if (obGuideStep.value === 2 && mode === 'table') obGuideStep.value = 3
  if (mode === 'calendar') loadCal()
}

// ── 行事曆狀態 ─────────────────────────────────────────
const CAL_WEEK_DAYS = ['日', '一', '二', '三', '四', '五', '六']
const calNow        = new Date()
const calYear       = ref(calNow.getFullYear())
const calMonthNum   = ref(calNow.getMonth() + 1)
const calAllSlots   = ref([])
const calNotes      = ref({})
const calLoading    = ref(false)
const calDayPopup   = ref(null)

const calDaysInMonth  = computed(() => new Date(calYear.value, calMonthNum.value, 0).getDate())
const calFirstWeekday = computed(() => new Date(calYear.value, calMonthNum.value - 1, 1).getDay())

function calIsToday(day) {
  const t = new Date()
  return t.getFullYear() === calYear.value && t.getMonth() + 1 === calMonthNum.value && t.getDate() === day
}
function calDateStr(day) {
  return `${calYear.value}-${String(calMonthNum.value).padStart(2,'0')}-${String(day).padStart(2,'0')}`
}

const calByDate = computed(() => {
  const map = {}
  for (const s of calAllSlots.value) {
    if (!map[s.slot_date]) map[s.slot_date] = []
    map[s.slot_date].push(s)
  }
  return map
})

function calSlotsForDay(day) {
  let list = calByDate.value[calDateStr(day)] || []
  // 延伸格（continuation）不顯示，起始格已顯示完整時間
  list = list.filter(s => !s.is_continuation)
  if (filterTeacher.value) list = list.filter(s => s.teacher_name === filterTeacher.value)
  if (filterStatus.value === 'available') list = list.filter(s => s.status === 'available' && s.booked_count < s.capacity)
  if (filterStatus.value === 'full')      list = list.filter(s => s.status === 'available' && s.booked_count >= s.capacity)
  if (filterStatus.value === 'blocked')   list = list.filter(s => s.status === 'blocked')
  return list
}

function calChipClass(s) {
  if (s.status === 'blocked')                       return 'sasl-cal-chip--blocked'
  if (s.booked_count >= s.capacity)                 return 'sasl-cal-chip--full'
  return 'sasl-cal-chip--available'
}

function calPrev() {
  if (calMonthNum.value === 1) { calYear.value--; calMonthNum.value = 12 }
  else calMonthNum.value--
  loadCal()
}
function calNext() {
  if (calMonthNum.value === 12) { calYear.value++; calMonthNum.value = 1 }
  else calMonthNum.value++
  loadCal()
}
function calToday() {
  const t = new Date()
  calYear.value = t.getFullYear()
  calMonthNum.value = t.getMonth() + 1
  loadCal()
}
const popupNote          = ref('')
const popupNoteSavedText = ref('')
const popupNoteEditing   = ref(false)
const popupNoteSaving    = ref(false)
const popupNoteSaved     = ref(false)

async function openCalDay(day) {
  calDayPopup.value      = day
  popupNoteEditing.value = false
  popupNoteSaved.value   = false
  await loadPopupNote()
}

async function loadPopupNote() {
  if (calDayPopup.value === null) return
  const dateStr = calDateStr(calDayPopup.value)
  const teacher = filterTeacher.value || ''
  try {
    const res = await fetch(
      `/api/store-admin/day-note?date=${dateStr}&teacher=${encodeURIComponent(teacher)}`,
      { headers: storeAdminStore._headers() }
    )
    const json = await res.json()
    popupNote.value          = json.note || ''
    popupNoteSavedText.value = json.note || ''
  } catch {
    popupNote.value          = ''
    popupNoteSavedText.value = ''
  }
}

async function savePopupNote() {
  popupNoteSaving.value = true
  popupNoteSaved.value  = false
  const dateStr = calDateStr(calDayPopup.value)
  const teacher = filterTeacher.value
  // 若備註未包含老師名稱前綴，自動加入
  let noteToSave = popupNote.value
  if (teacher && noteToSave && !noteToSave.startsWith(teacher)) {
    noteToSave = teacher + noteToSave
  }
  try {
    await fetch('/api/store-admin/day-note', {
      method: 'POST',
      headers: { ...storeAdminStore._headers(), 'Content-Type': 'application/json' },
      body: JSON.stringify({ date: dateStr, note: noteToSave, teacher_name: teacher })
    })
    popupNote.value          = noteToSave
    popupNoteSavedText.value = noteToSave
    popupNoteEditing.value   = false
    popupNoteSaved.value     = true
    // 同步更新行事曆格子（per-teacher 結構）
    if (!calNotes.value[dateStr]) calNotes.value[dateStr] = {}
    if (noteToSave) {
      calNotes.value[dateStr][teacher] = noteToSave
    } else {
      delete calNotes.value[dateStr][teacher]
      if (Object.keys(calNotes.value[dateStr]).length === 0) delete calNotes.value[dateStr]
    }
    // 清除舊格式備註（teacher_name=''）中屬於此老師的殘留
    if (teacher && calNotes.value[dateStr]?.[''] &&
        calNotes.value[dateStr][''].startsWith(teacher)) {
      delete calNotes.value[dateStr]['']
      if (Object.keys(calNotes.value[dateStr]).length === 0) delete calNotes.value[dateStr]
    }
    setTimeout(() => { popupNoteSaved.value = false }, 2000)
  } finally {
    popupNoteSaving.value = false
  }
}

async function clearPopupNote() {
  popupNote.value = ''
  await savePopupNote()
  popupNoteSavedText.value = ''
}

async function setPopupVacation() {
  const dateStr = calDateStr(calDayPopup.value)
  const teacher = filterTeacher.value

  if (!teacher) {
    alert('請先在上方選擇特定老師，再執行全天休假（避免誤刪其他老師的時段）。')
    return
  }

  // 取得該老師當天所有時段（不受狀態篩選影響）
  const allDay = (calByDate.value[calDateStr(calDayPopup.value)] || [])
    .filter(s => !s.is_continuation)
    .filter(s => !teacher || s.teacher_name === teacher)

  if (allDay.length === 0) {
    alert('此日期無可清除的時段')
    return
  }

  const bookedCount = allDay.filter(s => s.booked_count > 0).length
  const label = teacher ? `${teacher}` : '所有老師'

  if (bookedCount > 0) {
    const ok = confirm(
      `⚠️ ${label} 在 ${dateStr} 有 ${bookedCount} 個時段含有預約。\n` +
      `確認後將清除 ${label} 所有時段（其他老師不受影響）。\n\n確認設為休假？`
    )
    if (!ok) return
  } else {
    const ok = confirm(`確認清除 ${label} 在 ${dateStr} 的 ${allDay.length} 個時段並設為休假？`)
    if (!ok) return
  }

  let url = `/api/store-admin/slots/day/${dateStr}`
  if (teacher) url += `?teacher_name=${encodeURIComponent(teacher)}`

  const res = await fetch(url, { method: 'DELETE', headers: storeAdminStore._headers() })
  const json = await res.json()
  if (json.success) {
    calDayPopup.value = null
    loadCal()
  } else {
    alert(json.message || '操作失敗')
  }
}

async function loadCal() {
  const yr  = calYear.value
  const mo  = String(calMonthNum.value).padStart(2,'0')
  const days = new Date(yr, calMonthNum.value, 0).getDate()
  const date_from = `${yr}-${mo}-01`
  const date_to   = `${yr}-${mo}-${String(days).padStart(2,'0')}`
  calLoading.value = true
  calAllSlots.value = []
  calNotes.value    = {}
  const result = await storeAdminStore.fetchSlotsRange(date_from, date_to)
  calLoading.value = false
  if (result.unauthorized) { router.replace({ name: 'StoreAdminLogin' }); return }
  calAllSlots.value = result.slots || []
  calNotes.value    = result.notes || {}
}

// ── 老師篩選（從服務頁跳過來時帶入）────────────────────
const filterTeacher     = ref(route.query.teacher || '')
const filterStatus      = ref('')

const teacherList       = ref([])   // 老師清單（直接進入頁面時載入）

async function loadTeachers() {
  const result = await storeAdminStore.fetchServices()
  if (result?.success && Array.isArray(result.services)) {
    const names = [...new Set(result.services.map(s => s.name).filter(Boolean))]
    teacherList.value = names
  }
}



// 初始化時載入老師清單，並載入行事曆（預設行事曆模式）
loadTeachers()
loadCal()

// ── 今日（Asia/Taipei）──────────────────────────────
const todayTW = new Date().toLocaleDateString('en-CA', { timeZone: 'Asia/Taipei' })

// ── 當前月份（YYYY-MM）──────────────────────────────
const currentYear  = ref(Number(todayTW.slice(0, 4)))
const currentMonth = ref(Number(todayTW.slice(5, 7)))

const currentYearMonth = computed(() => {
  const m = String(currentMonth.value).padStart(2, '0')
  return `${currentYear.value} 年 ${m} 月`
})

// 切換月份時，同步把 selectedDate 設為該月第一天
// 若切回當月，則設為今天
function prevMonth() {
  if (currentMonth.value === 1) {
    currentYear.value--
    currentMonth.value = 12
  } else {
    currentMonth.value--
  }
  syncDateToMonth()
}
function nextMonth() {
  if (currentMonth.value === 12) {
    currentYear.value++
    currentMonth.value = 1
  } else {
    currentMonth.value++
  }
  syncDateToMonth()
}

function syncDateToMonth() {
  const y = currentYear.value
  const m = String(currentMonth.value).padStart(2, '0')
  const todayYear  = Number(todayTW.slice(0, 4))
  const todayMonth = Number(todayTW.slice(5, 7))
  // 若切回今天所在月份 → 選今天；否則選該月第一天
  if (y === todayYear && currentMonth.value === todayMonth) {
    selectedDate.value = todayTW
  } else {
    selectedDate.value = `${y}-${m}-01`
  }
  // 捲動日期列到選取日
  nextTick(() => scrollToSelected())
}

// ── 當月所有日期 ─────────────────────────────────────
const DOW_LABELS = ['日', '一', '二', '三', '四', '五', '六']

const daysInMonth = computed(() => {
  const y = currentYear.value
  const m = currentMonth.value
  const count = new Date(y, m, 0).getDate()
  const result = []
  for (let d = 1; d <= count; d++) {
    const date = `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`
    const dow  = new Date(`${date}T00:00:00+08:00`).getDay()
    result.push({ date, num: d, dow: DOW_LABELS[dow] })
  }
  return result
})

// ── 選定日期 ─────────────────────────────────────────
const selectedDate = ref(todayTW)
const dayStripRef  = ref(null)

function selectDate(date) {
  selectedDate.value     = date
  dayNote.value          = ''
  dayNoteSavedText.value = ''
  dayNoteSaved.value     = false
  dayNoteEditing.value   = false
  loadDayNote()
}

function scrollToSelected() {
  if (!dayStripRef.value) return
  const el = dayStripRef.value.querySelector('.sasl-day-chip--selected')
  if (el) el.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
}

// ── 時段資料 ─────────────────────────────────────────
const slots        = ref([])
const slotsLoading = ref(false)
const slotsError   = ref('')

async function loadSlots() {
  if (!selectedDate.value) return
  slotsLoading.value = true
  slotsError.value   = ''
  // 後端 GET /slots?date=YYYY-MM-DD → 單日查詢
  const result = await storeAdminStore.fetchSlots(selectedDate.value)
  if (result.unauthorized) {
    router.replace({ name: 'StoreAdminLogin' })
    return
  }
  if (result.success) {
    slots.value = result.slots
  } else {
    slotsError.value = result.message || '載入時段失敗'
  }
  slotsLoading.value = false
}

// 切換選定日期時自動重撈 + 載入備註
watch(selectedDate, () => { loadSlots(); loadDayNote() }, { immediate: true })
// 切換老師時：重新載入備註（行事曆 popup 與非行事曆模式）
watch(filterTeacher, () => {
  if (calDayPopup.value !== null) {
    popupNoteEditing.value = false
    popupNoteSaved.value   = false
    loadPopupNote()
  }
  if (viewMode.value !== 'calendar' && selectedDate.value) {
    loadDayNote()
  }
})

// ── 依老師 + 狀態篩選顯示的時段 ─────────────────────
const displaySlots = computed(() => {
  let list = slots.value
  // 延伸格（continuation）：起始格已顯示完整時間，後續佔用格不需要重複列出
  list = list.filter(s => !s.reservation?.is_continuation)
  if (filterTeacher.value) list = list.filter(s => s.teacher_name === filterTeacher.value)
  if (filterStatus.value === 'available') list = list.filter(s => s.status === 'available' && s.booked_count < s.capacity)
  if (filterStatus.value === 'full')      list = list.filter(s => s.status === 'available' && s.booked_count >= s.capacity)
  if (filterStatus.value === 'blocked')   list = list.filter(s => s.status === 'blocked')
  return list
})

// ── 時段卡片樣式輔助（以 slot.status 為主）────────────
// status: 'available' | 'blocked'
// full 狀態：status === 'available' 且 booked_count >= capacity → 自動顯示，不可手動設定
function slotCardClass(slot) {
  if (slot.status === 'blocked')                        return 'sasl-slot-card--blocked'
  if (slot.booked_count >= slot.capacity)               return 'sasl-slot-card--full'
  return 'sasl-slot-card--available'
}

function slotTagClass(slot) {
  if (slot.status === 'blocked')                           return 'sasl-slot-tag--blocked'
  if (slot.booked_count >= slot.capacity)                  return 'sasl-slot-tag--full'
  if (slot.capacity > 1 && slot.booked_count > 0)         return 'sasl-slot-tag--partial'
  return 'sasl-slot-tag--available'
}

function slotTagLabel(slot) {
  if (slot.status === 'blocked')                           return '已封鎖'
  if (slot.booked_count >= slot.capacity)                  return '已額滿'
  if (slot.capacity > 1 && slot.booked_count > 0)         return `已預約（${slot.booked_count}位）`
  return `可預約（${slot.capacity - slot.booked_count}位）`
}


function capPercent(slot) {
  if (!slot.capacity) return 100
  return Math.min(100, Math.round((slot.booked_count / slot.capacity) * 100))
}



function fmtTime(t) {
  return t ? t.slice(0, 5) : ''
}

// ── 刪除時段 ─────────────────────────────────────────
const deleteLoading = ref({})
const deleteError   = ref({})

// ── 修改人數 ─────────────────────────────────────────
const editCapSlot    = ref(null)   // 正在編輯的 slot.id
const editCapVal     = ref(1)
const editCapLoading = ref(false)
const editCapError   = ref('')

function startEditCap(slot) {
  editCapSlot.value  = slot.id
  editCapVal.value   = slot.capacity
  editCapError.value = ''
}

async function saveCapacity(slot) {
  editCapError.value   = ''
  editCapLoading.value = true
  try {
    const res = await fetch(`/api/store-admin/slots/${slot.id}`, {
      method: 'PUT',
      headers: { ...storeAdminStore._headers(), 'Content-Type': 'application/json' },
      body: JSON.stringify({ capacity: Number(editCapVal.value) })
    })
    const json = await res.json()
    if (json.success) {
      slot.capacity      = Number(editCapVal.value)
      editCapSlot.value  = null
      if (viewMode.value === 'calendar') loadCal()
    } else {
      editCapError.value = json.message || '更新失敗'
    }
  } catch {
    editCapError.value = '更新失敗，請稍後再試'
  } finally {
    editCapLoading.value = false
  }
}

// ── 當日備註 ─────────────────────────────────────────
const dayNote        = ref('')
const dayNoteSavedText = ref('')   // 已儲存的備註（用於顯示）
const dayNoteEditing = ref(false)
const dayNoteSaving  = ref(false)
const dayNoteSaved   = ref(false)

async function loadDayNote() {
  if (!selectedDate.value) return
  const teacher = filterTeacher.value || ''
  try {
    const res = await fetch(
      `/api/store-admin/day-note?date=${selectedDate.value}&teacher=${encodeURIComponent(teacher)}`,
      { headers: storeAdminStore._headers() }
    )
    const json = await res.json()
    dayNote.value          = json.note || ''
    dayNoteSavedText.value = json.note || ''
    dayNoteEditing.value   = false
  } catch {
    dayNote.value          = ''
    dayNoteSavedText.value = ''
  }
}

async function saveDayNote() {
  dayNoteSaving.value = true
  dayNoteSaved.value  = false
  const teacher = filterTeacher.value
  let noteToSave = dayNote.value
  if (teacher && noteToSave && !noteToSave.startsWith(teacher)) {
    noteToSave = teacher + noteToSave
  }
  try {
    await fetch('/api/store-admin/day-note', {
      method: 'POST',
      headers: { ...storeAdminStore._headers(), 'Content-Type': 'application/json' },
      body: JSON.stringify({ date: selectedDate.value, note: noteToSave, teacher_name: teacher })
    })
    dayNote.value          = noteToSave
    dayNoteSavedText.value = noteToSave
    dayNoteEditing.value   = false
    dayNoteSaved.value     = true
    setTimeout(() => { dayNoteSaved.value = false }, 2000)
  } finally {
    dayNoteSaving.value = false
  }
}

async function clearDayNote() {
  dayNote.value = ''
  await saveDayNote()
  dayNoteSavedText.value = ''
}

// ── 全天休假 ─────────────────────────────────────────
// 當日已有預約的時段（booked_count > 0），依老師篩選
const bookedSlotsOnDay = computed(() =>
  (filterTeacher.value ? displaySlots.value : slots.value).filter(s => s.booked_count > 0)
)

const holidaying       = ref(false)
const showHolidayModal = ref(false)
const holidayReason    = ref('')

function markHoliday() {
  if (!filterTeacher.value) {
    alert('請先在上方選擇特定老師，再執行全天休假（避免誤刪其他老師的時段）。')
    return
  }
  holidayReason.value    = ''
  showHolidayModal.value = true
}

async function confirmHoliday() {
  holidaying.value = true
  try {
    const result = await storeAdminStore.deleteSlotsByDay(selectedDate.value, filterTeacher.value || null)
    if (result.unauthorized) {
      router.replace({ name: 'StoreAdminLogin' })
      return
    }
    if (result.success) {
      // 儲存休假原因為當日備註
      if (holidayReason.value.trim()) {
        await fetch('/api/store-admin/day-note', {
          method: 'POST',
          headers: { ...storeAdminStore._headers(), 'Content-Type': 'application/json' },
          body: JSON.stringify({ date: selectedDate.value, note: holidayReason.value.trim(), teacher_name: filterTeacher.value || '' })
        })
        dayNote.value = holidayReason.value.trim()
      }
      showHolidayModal.value = false
      await loadSlots()
    } else {
      alert(result.message || '操作失敗')
    }
  } finally {
    holidaying.value = false
  }
}

async function deleteSlot(slot) {
  const timeLabel = `${fmtTime(slot.start_time)}–${fmtTime(slot.end_time)}`
  let msg = `確定刪除 ${timeLabel} 這個時段？`
  if (slot.booked_count > 0) {
    msg += `\n\n⚠ 此時段有 ${slot.booked_count} 筆預約，強制刪除後相關預約將一併取消。`
  }
  if (!confirm(msg)) return

  deleteLoading.value[slot.id] = true
  deleteError.value[slot.id]   = ''

  const result = await storeAdminStore.deleteSlot(slot.id)

  if (result.unauthorized) {
    router.replace({ name: 'StoreAdminLogin' })
    return
  }

  if (result.success) {
    slots.value = slots.value.filter(s => s.id !== slot.id)
    if (result.cancelledCount > 0) {
      alert(`時段已刪除，同時取消了 ${result.cancelledCount} 筆預約。`)
    }
  } else {
    deleteError.value[slot.id] = result.message || '刪除失敗'
  }

  deleteLoading.value[slot.id] = false
}

// ── 批次建立時段 Modal ──────────────────────────────
const showBatch        = ref(false)
const batchSubmitting  = ref(false)
const batchError       = ref('')
const batchResult      = ref(null)
const batchErrors      = ref({})
const batchConflicts   = ref([])

const emptyBatchForm = () => ({
  start_date: selectedDate.value || todayTW,
  end_date:   selectedDate.value || todayTW,
  day_start:  '09:00',
  day_end:    '18:00',
  next_day:   false,
  interval:   60,
})
const batchForm = ref(emptyBatchForm())

// 分鐘數 → 時間字串（支援超過 24h，例如 1530min → '25:30'）
function minsToTimeStr(mins) {
  const h = Math.floor(mins / 60)
  const m = mins % 60
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`
}

// 產生時段陣列（支援隔天）
function generateSlots(dayStart, dayEnd, interval, nextDay = false) {
  if (!dayStart || !dayEnd || !interval) return []
  const [sh, sm] = dayStart.split(':').map(Number)
  const [eh, em] = dayEnd.split(':').map(Number)
  let cur = sh * 60 + sm
  const end = eh * 60 + em + (nextDay ? 24 * 60 : 0)
  if (end <= cur) return []
  const slots = []
  while (cur + interval <= end) {
    const s = minsToTimeStr(cur)
    cur += interval
    slots.push({ start_time: s, end_time: minsToTimeStr(cur) })
  }
  return slots
}

// 預覽文字
const batchPreview = computed(() => {
  const { day_start, day_end, interval, next_day } = batchForm.value
  if (!day_start || !day_end || !interval) return '請填寫時間'
  const slots = generateSlots(day_start, day_end, interval, next_day)
  if (slots.length === 0) return '時間設定有誤（結束需晚於開始）'
  const endLabel = next_day ? `隔天 ${day_end}` : day_end
  return `${day_start} 至 ${endLabel}，共 ${slots.length} 個時段`
})



function closeBatch() { showBatch.value = false }

// ── 新手引導（步驟 4：新增時段）────────────────────
const obSlKey      = computed(() => `jili_ob_sl_${storeAdminStore.storeId || ''}`)
const onboarding4  = computed(() => route.query.onboard === '4')
const showObBanner = ref(false)
// obGuideStep: 0=未啟動, 1=看行事曆→點卡片, 2=看卡片→點表格, 3=完成→下一步按鈕
const obGuideStep  = ref(0)

watch(() => route.query.onboard, (val) => {
  if (val !== '4') return
  if (localStorage.getItem(obSlKey.value)) {
    // 已從服務管理批次建立完成，直接進 tab 導覽
    viewMode.value    = 'calendar'
    loadCal()
    obGuideStep.value = 1
  } else {
    // 正常從服務管理「下一步」過來，顯示引導橫幅
    showObBanner.value = true
  }
}, { immediate: true })

function validateBatch() {
  const e = {}
  if (!batchForm.value.start_date) e.start_date = '請選擇開始日期'
  if (!batchForm.value.end_date)   e.end_date   = '請選擇結束日期'
  if (batchForm.value.start_date && batchForm.value.end_date &&
      batchForm.value.end_date < batchForm.value.start_date) {
    e.end_date = '結束日期不得早於開始日期'
  }
  const slots = generateSlots(
    batchForm.value.day_start, batchForm.value.day_end,
    batchForm.value.interval,  batchForm.value.next_day
  )
  if (slots.length === 0) e.slots = '時間設定有誤，無法產生任何時段'
  batchErrors.value = e
  return Object.keys(e).length === 0
}

async function submitBatch() {
  batchError.value     = ''
  batchResult.value    = null
  batchConflicts.value = []
  if (!validateBatch()) return

  const timeslots = generateSlots(batchForm.value.day_start, batchForm.value.day_end, batchForm.value.interval, batchForm.value.next_day)
  // 老師由 filterTeacher（從服務管理帶入）自動設定，未指定則為 null
  const slots = timeslots.map(ts => ({
    ...ts,
    teacher_name: filterTeacher.value || null,
    service_item: null,
  }))

  batchSubmitting.value = true
  try {
    const result = await storeAdminStore.createSlotsBatch({
      start_date: batchForm.value.start_date,
      end_date:   batchForm.value.end_date,
      slots,
    })

    if (result.unauthorized) {
      router.replace({ name: 'StoreAdminLogin' })
      return
    }

    if (result.success) {
      batchResult.value = { inserted: result.inserted }
      // 新手引導：標記完成，啟動 tab 導覽
      if (onboarding4.value || showObBanner.value) {
        localStorage.setItem(obSlKey.value, '1')
        showObBanner.value = false
        viewMode.value     = 'calendar'
        loadCal()
        obGuideStep.value  = 1
      }
      if (
        selectedDate.value &&
        selectedDate.value >= batchForm.value.start_date &&
        selectedDate.value <= batchForm.value.end_date
      ) {
        await loadSlots()
      }
    } else if (result.conflicts?.length) {
      batchConflicts.value = result.conflicts
    } else {
      batchError.value = result.message || '批次建立失敗'
    }
  } finally {
    batchSubmitting.value = false
  }
}
</script>

<style scoped>
.sasl-page {
  max-width: 860px;
}

/* 頁首 */
.sasl-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  gap: 12px;
  flex-wrap: wrap;
}
.sasl-title { font-size: 1.6rem; color: #2c3e50; margin: 0; }

/* 切換分頁 */
.sasl-view-tabs { display: flex; border: 1px solid #dce1e7; border-radius: 8px; overflow: hidden; }
.sasl-view-tab {
  padding: 6px 16px; background: #fff; border: none; cursor: pointer;
  font-size: 0.88rem; font-weight: 500; color: #7f8c8d;
  transition: background .15s, color .15s;
}
.sasl-view-tab--on { background: #2c3e50; color: #fff; }

/* 行事曆導覽列 */
.sasl-cal-nav {
  display: flex; flex-wrap: wrap; gap: 12px; align-items: center;
  justify-content: space-between;
  background: #fff; border: 1px solid #e8ecf0; border-radius: 10px;
  padding: 12px 16px; margin-bottom: 14px;
}
.sasl-cal-nav-left  { display: flex; align-items: center; gap: 8px; }
.sasl-cal-nav-right { display: flex; align-items: center; gap: 8px; }
.sasl-cal-title { font-size: 1.05rem; font-weight: 700; color: #2c3e50; min-width: 120px; text-align: center; }
.sasl-cal-nav .sasl-select-wrap { position: relative; display: inline-flex; align-items: center; }
.sasl-cal-nav .sasl-input { width: auto; min-width: 110px; padding-right: 28px; cursor: pointer; font-size: 0.88rem; padding-top: 7px; padding-bottom: 7px; }
.sasl-cal-nav .sasl-select-arrow { position: absolute; right: 8px; top: 50%; transform: translateY(-50%); font-size: 0.8rem; color: #7f8c8d; pointer-events: none; }

/* 行事曆格線 */
.sasl-cal-grid-wrap { overflow-x: auto; -webkit-overflow-scrolling: touch; border: 1px solid #dce1e7; border-radius: 10px; }
.sasl-cal-grid {
  display: grid; grid-template-columns: repeat(7, minmax(90px, 1fr));
  min-width: 650px; background: #e8ecf0; gap: 1px;
}
.sasl-cal-weekday {
  background: #2c3e50; color: #fff; text-align: center;
  padding: 8px 0; font-size: 0.82rem; font-weight: 700;
}
.sasl-cal-day {
  background: #fff; min-height: 100px; padding: 5px;
  display: flex; flex-direction: column; gap: 2px;
  position: relative;
}
.sasl-cal-day--blank { background: #f8f9fa; }
.sasl-cal-day--today .sasl-cal-day-num {
  background: #2c3e50; color: #fff; border-radius: 50%;
  width: 22px; height: 22px; display: flex; align-items: center; justify-content: center;
}
.sasl-cal-day-num {
  font-size: 0.8rem; font-weight: 600; color: #5d6d7e;
  width: 22px; height: 22px; display: flex; align-items: center; justify-content: center;
  margin-bottom: 2px; flex-shrink: 0; cursor: pointer; border-radius: 50%;
  transition: background .15s;
}
.sasl-cal-day-num:hover { background: #f4f6f9; }
.sasl-cal-events { display: flex; flex-direction: column; gap: 2px; flex: 1; overflow: hidden; }
.sasl-cal-day-note {
  font-size: 0.68rem; font-weight: 600;
  background: #ede9fe; color: #5b21b6;
  border-radius: 4px; padding: 2px 5px;
  margin-bottom: 2px; cursor: pointer;
  white-space: nowrap;
  overflow: hidden; text-overflow: ellipsis;
  width: 100%; box-sizing: border-box;
}
.sasl-popup-teacher-row {
  display: flex; align-items: center; gap: 8px;
  margin-bottom: 10px;
}
.sasl-popup-teacher-label { font-size: 0.82rem; color: #5d6d7e; font-weight: 600; white-space: nowrap; }
.sasl-input--sm { padding: 4px 8px; font-size: 0.82rem; }

/* 時段小方塊 */
.sasl-cal-chip {
  display: flex; align-items: center; gap: 3px;
  border-radius: 4px; padding: 2px 5px; font-size: 0.68rem;
  cursor: pointer; white-space: nowrap; overflow: hidden;
  transition: opacity .15s;
}
.sasl-cal-chip:hover { opacity: 0.8; }
.sasl-cal-chip--available { background: #eafaf1; color: #1e8449; border: 1px solid #a9dfbf; }
.sasl-cal-chip--full      { background: #fef5e7; color: #d35400; border: 1px solid #fad7a0; }
.sasl-cal-chip--blocked   { background: #f2f3f4; color: #7f8c8d; border: 1px solid #d5d8dc; }
.sasl-cal-chip-time   { font-weight: 700; flex-shrink: 0; }
.sasl-cal-chip-teacher { overflow: hidden; text-overflow: ellipsis; }
.sasl-cal-more {
  font-size: 0.65rem; color: #2c3e50; cursor: pointer;
  padding: 1px 4px; border-radius: 3px; background: #f4f6f9;
  text-align: center; font-weight: 600;
}
.sasl-cal-more:hover { background: #dce1e7; }

/* 行事曆 day popup */
.sasl-popup-note {
  border: 1px solid #e8e0da; border-radius: 8px;
  padding: 10px 14px; background: #fdf8f5; margin-bottom: 10px;
}
.sasl-popup-note__label { font-size: 0.78rem; color: #888; margin: 0 0 8px; font-weight: 600; }
.sasl-popup-note__row { display: flex; align-items: center; gap: 8px; }
.sasl-popup-note__text { flex: 1; font-size: 0.9rem; font-weight: 600; color: #5b21b6; }
.sasl-popup-note__input { flex: 1; padding: 6px 10px; font-size: 0.88rem; }
.sasl-popup-note__ok   { font-size: 0.8rem; color: #27ae60; margin: 6px 0 0; }
.sasl-popup-note__hint { font-size: 0.82rem; color: #999; font-style: italic; }
.sasl-popup-vacation { margin-bottom: 10px; }
.sasl-day-note-banner {
  background: #ede9fe; color: #5b21b6;
  border-radius: 8px; padding: 8px 14px;
  font-weight: 600; font-size: 0.9rem;
  margin-bottom: 12px;
}
.sasl-cal-day-list { display: flex; flex-direction: column; gap: 8px; max-height: 420px; overflow-y: auto; padding: 0 2px; }
.sasl-cal-day-item {
  display: flex; align-items: center; gap: 8px; flex-wrap: wrap;
  border: 1px solid #e8ecf0; border-radius: 8px; padding: 8px 12px;
  font-size: 0.88rem;
}
.sasl-cal-day-item__time    { font-weight: 700; color: #2c3e50; white-space: nowrap; flex-shrink: 0; }
.sasl-cal-day-item__teacher { color: #7f8c8d; flex-shrink: 0; }
.sasl-cal-day-item__cap     { margin-left: auto; color: #95a5a6; font-size: 0.82rem; white-space: nowrap; }

/* 老師篩選 banner */
.sasl-filter-bar {
  display: flex; align-items: center; justify-content: space-between;
  gap: 10px; flex-wrap: wrap;
  background: #eaf3fb; border: 1px solid #aed6f1; border-radius: 8px;
  padding: 10px 14px; margin-bottom: 16px; font-size: 0.88rem; color: #1a5276;
}
.sasl-filter-clear {
  background: none; border: 1px solid #aed6f1; border-radius: 6px;
  padding: 4px 10px; font-size: 0.82rem; color: #2471a3; cursor: pointer;
  white-space: nowrap;
}
.sasl-filter-clear:hover { background: #d6eaf8; }

/* 月份導覽 */
.sasl-month-nav {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 12px;
}
.sasl-month-label {
  font-size: 1rem;
  font-weight: 600;
  color: #2c3e50;
  min-width: 110px;
  text-align: center;
}
.sasl-month-btn {
  background: #fff;
  border: 1px solid #dce1e7;
  border-radius: 6px;
  padding: 6px 14px;
  cursor: pointer;
  font-size: 1rem;
  color: #555;
  transition: background 0.15s;
}
.sasl-month-btn:hover { background: #f4f6f9; }

/* 日期快捷列 */
.sasl-day-strip {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 6px;
  margin-bottom: 24px;
}
.sasl-day-chip {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  padding: 8px 4px;
  border-radius: 8px;
  border: 1px solid #dce1e7;
  background: #fff;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
  width: 100%;
}
.sasl-day-chip:hover { background: #f4f6f9; border-color: #aaa; }
.sasl-day-chip--selected {
  background: #2c3e50;
  border-color: #2c3e50;
  color: #fff;
}
.sasl-day-chip--today { border-color: #8b6f5c; }
.sasl-day-chip--past  { opacity: 0.4; }
.sasl-day-chip__dow {
  font-size: 0.7rem;
  color: inherit;
  opacity: 0.7;
}
.sasl-day-chip__num {
  font-size: 0.92rem;
  font-weight: 600;
  color: inherit;
}
.sasl-day-chip--selected .sasl-day-chip__dow,
.sasl-day-chip--selected .sasl-day-chip__num {
  color: #fff;
  opacity: 1;
}

/* 時段區域 */
.sasl-slots-area {
  background: #fff;
  border: 1px solid #e0e6ed;
  border-radius: 12px;
  padding: 20px;
  min-height: 200px;
}
.sasl-slots-date-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
}
.sasl-mode-btn {
  font-size: 0.82rem;
  padding: 5px 12px;
}

/* 表格模式 */
.sasl-table-wrap {
  overflow-x: auto;
  border-radius: 10px;
  border: 1px solid #e8e0da;
  background: #fff;
  margin-top: 12px;
}
.sasl-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.88rem;
}
.sasl-table thead th {
  background: #f9f6f3;
  color: #555;
  font-weight: 600;
  padding: 10px 14px;
  text-align: left;
  border-bottom: 1px solid #e8e0da;
  white-space: nowrap;
}
.sasl-table tbody tr {
  border-bottom: 1px solid #f3f3f3;
  transition: background 0.12s;
}
.sasl-table tbody tr:last-child { border-bottom: none; }
.sasl-table tbody tr:hover { background: #faf8f6; }
.sasl-table td { padding: 9px 14px; vertical-align: middle; }
.sasl-tr--full { background: #fff5f5; }

.sasl-slots-date {
  font-size: 1rem;
  font-weight: 600;
  color: #2c3e50;
  margin: 0 0 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.sasl-today-tag {
  font-size: 0.75rem;
  background: #8b6f5c;
  color: #fff;
  border-radius: 10px;
  padding: 2px 8px;
  font-weight: normal;
}

/* 狀態 */
.sasl-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 40px 16px;
  color: #aaa;
  text-align: center;
}
.sasl-state--error { color: #c0392b; }
.sasl-state--hint  { color: #bbb; }

.sasl-spinner {
  display: inline-block;
  width: 28px; height: 28px;
  border: 3px solid #ddd;
  border-top-color: #8b6f5c;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}
.sasl-spinner--sm    { width: 16px; height: 16px; border-width: 2px; }
.sasl-spinner--white { border-color: rgba(255,255,255,0.3); border-top-color: #fff; }
@keyframes spin { to { transform: rotate(360deg); } }

/* 時段列表 */
.sasl-slot-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.sasl-slot-card {
  border: 1px solid #e0e6ed;
  border-radius: 10px;
  padding: 14px 16px;
  transition: opacity 0.2s;
}
.sasl-slot-card--available { border-left: 4px solid #27ae60; }
.sasl-slot-card--full      { border-left: 4px solid #e74c3c; opacity: 0.8; }
.sasl-slot-card--blocked   { border-left: 4px solid #bdc3c7; opacity: 0.6; }

.sasl-slot-card__top {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 10px;
  flex-wrap: wrap;
}
.sasl-slot-card__time {
  font-size: 1rem;
  font-weight: 700;
  color: #2c3e50;
}

/* 狀態標籤 */
.sasl-slot-tag {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
}
.sasl-slot-tag--available { background: #d4edda; color: #155724; }
.sasl-slot-tag--partial   { background: #fff3cd; color: #856404; }
.sasl-slot-tag--full      { background: #f8d7da; color: #721c24; }
.sasl-slot-tag--blocked   { background: #e9ecef; color: #6c757d; }

.sasl-bed-label {
  display: inline-block;
  font-size: 0.72rem;
  font-weight: 600;
  color: #6d4c41;
  background: #f3e5d8;
  border: 1px solid #d4a87a;
  border-radius: 20px;
  padding: 1px 8px;
  margin-left: 4px;
  white-space: nowrap;
  vertical-align: middle;
}

/* 容量條 */
.sasl-slot-card__teacher {
  font-size: 0.83rem;
  color: #5d6d7e;
  margin: 2px 0 6px;
  font-weight: 500;
}
.sasl-slot-card__reservation {
  display: flex; flex-direction: column; gap: 2px;
  margin: 4px 0 6px;
  padding: 6px 10px;
  background: #f0f9ff; border-radius: 6px;
  border-left: 3px solid #3498db;
}
.sasl-res-row      { display: flex; align-items: center; gap: 6px; }
.sasl-res-customer { font-size: 0.85rem; font-weight: 600; color: #2c3e50; }
.sasl-res-phone    { font-size: 0.8rem; color: #4a4a4a; }
.sasl-res-meta     { font-size: 0.78rem; color: #5d6d7e; }
.sasl-res-via      { font-size: 0.78rem; font-weight: 600; color: #06c755; }
.sasl-res-uid      { font-size: 0.8rem; color: #555; font-family: monospace; user-select: all; background: #e8f4fd; border-radius: 4px; padding: 2px 6px; }

.sasl-slot-card__continuation {
  font-size: 0.78rem; color: #8e8e8e;
  margin: 4px 0 6px;
  padding: 5px 10px;
  background: #f9f9f9; border-radius: 6px;
  border-left: 3px solid #ddd;
  font-style: italic;
}
.sasl-slot-card__continuation-compact {
  font-size: 0.82rem;
  color: #9b9b9b;
  padding: 2px 0 8px;
  font-style: italic;
}

.sasl-slot-card__cap {
  font-size: 0.82rem;
  color: #7f8c8d;
  margin-bottom: 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
/* 老師列 */
.sasl-teacher-row   { display: flex; gap: 8px; align-items: center; margin-bottom: 6px; }
.sasl-teacher-input { flex: 1; }
.sasl-teacher-remove { flex: 0 0 auto; }
.sasl-cap-bar {
  height: 4px;
  background: #e9ecef;
  border-radius: 2px;
  overflow: hidden;
  max-width: 200px;
}
.sasl-cap-bar__fill {
  height: 100%;
  background: #27ae60;
  border-radius: 2px;
  transition: width 0.3s;
}
.sasl-cap-bar__fill--full { background: #e74c3c; }

/* 編輯區 */
.sasl-slot-card__edit {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 12px;
  margin-top: 4px;
}
.sasl-inline-field {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 8px;
}
.sasl-inline-field label {
  font-size: 0.85rem;
  color: #555;
  white-space: nowrap;
}
.sasl-inline-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
/* ── 修改人數 ──────────────────────────────────────── */
/* 多人預約分隔 */
.sasl-slot-card__reservations { display: flex; flex-direction: column; gap: 0; }
.sasl-res-item--border {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px dashed #e0d8d0;
}

.sasl-cap-edit {
  margin-top: 10px;
  padding: 10px 12px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.sasl-cap-warn {
  font-size: 0.83rem;
  color: #b45309;
  background: #fffbeb;
  border: 1px solid #fcd34d;
  border-radius: 6px;
  padding: 8px 10px;
  line-height: 1.5;
}
.sasl-cap-edit-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.sasl-cap-edit-label {
  font-size: 0.85rem;
  color: #555;
  white-space: nowrap;
}
.sasl-cap-input {
  width: 64px;
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 4px 8px;
  font-size: 0.9rem;
  text-align: center;
}
/* 表格模式展開列 */
.sasl-cap-edit-row-tr td { padding: 0 !important; }
.sasl-cap-edit-td {
  padding: 8px 12px !important;
  background: #f8f9fa;
}
.sasl-table-actions { display: flex; gap: 6px; flex-wrap: wrap; }

.sasl-inline-error {
  font-size: 0.8rem;
  color: #e74c3c;
  margin: 4px 0 0;
}

.sasl-slot-card__actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

/* 按鈕 */
.sasl-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 10px 20px;
  border-radius: 7px;
  border: none;
  font-size: 0.95rem;
  cursor: pointer;
  transition: background 0.15s, opacity 0.15s;
  white-space: nowrap;
}
.sasl-btn:disabled { opacity: 0.5; cursor: not-allowed; }
.sasl-btn--sm      { font-size: 0.82rem; padding: 7px 14px; }
.sasl-btn--primary   { background: #2c3e50; color: #fff; }
.sasl-btn--primary:hover:not(:disabled)   { background: #34495e; }
.sasl-btn--secondary { background: transparent; border: 1px solid #bdc3c7; color: #555; }
.sasl-btn--secondary:hover:not(:disabled) { background: #f4f6f9; }
.sasl-btn--warn      { background: #e67e22; color: #fff; }
.sasl-btn--warn:hover:not(:disabled)      { background: #ca6f1e; }
.sasl-btn--success   { background: #27ae60; color: #fff; }
.sasl-btn--success:hover:not(:disabled)   { background: #229954; }
.sasl-btn--danger    { background: #e74c3c; color: #fff; }
.sasl-btn--danger:hover:not(:disabled)    { background: #c0392b; }
.sasl-btn--danger-outline {
  background: transparent;
  border: 1px solid #e74c3c;
  color: #e74c3c;
}
.sasl-btn--danger-outline:hover:not(:disabled) { background: #fdf0ef; }

.sasl-holiday-bar {
  margin-bottom: 12px;
}

.sasl-batch-exist-warn {
  background: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 8px;
  padding: 8px 14px;
  font-size: 0.85rem;
  color: #856404;
  margin-bottom: 14px;
}

/* 當日備註 */
.sasl-day-note {
  margin-top: 16px;
  background: #f9f6f3;
  border: 1px solid #e8ddd7;
  border-radius: 10px;
  padding: 14px 16px;
  text-align: left;
}
.sasl-day-note__label {
  font-size: 0.85rem;
  font-weight: 600;
  color: #555;
  margin: 0 0 8px;
}
.sasl-day-note__row {
  display: flex;
  gap: 8px;
  align-items: center;
}
.sasl-day-note__input {
  flex: 1;
  font-size: 0.88rem;
}
.sasl-day-note__current {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #fff;
  border: 1px solid #c8e6c9;
  border-radius: 8px;
  padding: 8px 12px;
  margin-bottom: 8px;
}
.sasl-day-note__current-text {
  flex: 1;
  font-size: 0.92rem;
  font-weight: 600;
  color: #2d7a4f;
}
.sasl-day-note__ok {
  font-size: 0.82rem;
  color: #2d7a4f;
  margin: 6px 0 0;
}

/* Modal footer */
.sasl-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 16px 24px;
  border-top: 1px solid #e9ecef;
}
.sasl-modal--sm { max-width: 420px; }

/* Modal */
.sasl-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.45);
  z-index: 500;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 16px;
  overflow-y: auto;
}
.sasl-modal {
  background: #fff;
  border-radius: 14px;
  width: 100%;
  max-width: 560px;
  margin: auto;
  box-shadow: 0 8px 40px rgba(0,0,0,0.18);
}
.sasl-modal__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px 16px;
  border-bottom: 1px solid #e9ecef;
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 1;
  border-radius: 14px 14px 0 0;
}
.sasl-modal__title { font-size: 1.1rem; color: #2c3e50; margin: 0; }
.sasl-modal__close {
  background: none;
  border: none;
  font-size: 1.1rem;
  cursor: pointer;
  color: #aaa;
  padding: 4px 8px;
  border-radius: 4px;
  line-height: 1;
}
.sasl-modal__close:hover { background: #f4f6f9; color: #555; }
.sasl-modal__body {
  padding: 20px 24px;
}
/* 全天休假按鈕區 */
.sasl-holiday-btn-wrap { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
.sasl-holiday-hint { font-size: 0.82rem; color: #e65100; font-weight: 600; }
.sasl-btn--disabled-hint { opacity: 0.6; }

/* 全天休假警告 */
.sasl-holiday-warning {
  background: #fff0f0;
  border: 2px solid #e74c3c;
  border-radius: 10px;
  padding: 14px 16px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(231,76,60,0.15);
}
.sasl-holiday-warning__title {
  font-size: 0.95rem; font-weight: 800; color: #c0392b;
  margin: 0 0 10px; display: flex; align-items: center; gap: 6px;
  letter-spacing: 0.01em;
}
.sasl-holiday-warning__list {
  margin: 0 0 10px; padding-left: 18px;
  font-size: 0.88rem; color: #2c3e50; line-height: 2;
}
.sasl-holiday-warning__list li {
  background: #fdecea; border-radius: 4px;
  padding: 2px 8px; margin-bottom: 4px; list-style: none; margin-left: -18px;
  border-left: 3px solid #e74c3c;
}
.sasl-holiday-warning__count  { color: #c0392b; font-weight: 700; }
.sasl-holiday-warning__teacher { color: #7f8c8d; font-size: 0.82rem; }
.sasl-holiday-warning__hint {
  font-size: 0.84rem; color: #c0392b; margin: 0;
  font-weight: 700; background: #fdecea;
  border-radius: 6px; padding: 6px 10px;
  border: 1px dashed #e74c3c;
}

.sasl-modal__desc {
  font-size: 0.88rem;
  color: #7f8c8d;
  margin: 0 0 20px;
  line-height: 1.5;
}
.sasl-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 24px 20px;
  border-top: 1px solid #e9ecef;
  flex-wrap: wrap;
}

/* 表單 */
.sasl-field { margin-bottom: 16px; }
.sasl-field label {
  display: block;
  font-size: 0.88rem;
  color: #555;
  font-weight: 500;
  margin-bottom: 6px;
}
.sasl-field--inline {
  margin-bottom: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.sasl-required { color: #e74c3c; }

.sasl-field-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
  margin-bottom: 16px;
}

/* 篩選列（老師 + 狀態） */
.sasl-filter-bar {
  display: flex; align-items: center; flex-wrap: wrap; gap: 16px;
  background: #fff; border: 1px solid #e8ecf0; border-radius: 10px;
  padding: 10px 16px; margin-bottom: 14px;
}
.sasl-filter-item { display: flex; align-items: center; gap: 8px; }
.sasl-filter-label {
  font-size: 0.82rem; color: #7f8c8d; font-weight: 500; white-space: nowrap;
}
.sasl-filter-bar .sasl-select-wrap { position: relative; display: inline-flex; align-items: center; }
.sasl-filter-bar .sasl-input { width: auto; min-width: 120px; padding-right: 32px; cursor: pointer; }
.sasl-select-arrow {
  position: absolute; right: 10px; top: 50%; transform: translateY(-50%);
  font-size: 0.85rem; color: #7f8c8d; pointer-events: none; line-height: 1;
}

.sasl-input {
  width: 100%;
  padding: 10px 13px;
  border: 1px solid #dce1e7;
  border-radius: 8px;
  font-size: 0.95rem;
  background: #fff;
  box-sizing: border-box;
  transition: border-color 0.15s;
  -webkit-appearance: none;
}
.sasl-input:focus {
  outline: none;
  border-color: #2c3e50;
  box-shadow: 0 0 0 3px rgba(44,62,80,0.07);
}
.sasl-input--error { border-color: #e74c3c; }
.sasl-input--time  { max-width: 130px; }
.sasl-input--short { max-width: 80px; }

.sasl-field-error {
  font-size: 0.8rem;
  color: #e74c3c;
  margin: 2px 0 0;
}

/* 批次表單 - 新版（同主後台） */
.sasl-batch-schedule {
  border: 1px solid #e0e6ed;
  border-radius: 8px;
  padding: 14px;
  background: #fafbfc;
  margin-top: 6px;
}
.sasl-batch-row {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  align-items: flex-end;
}
.sasl-batch-col { display: flex; flex-direction: column; gap: 5px; }
.sasl-batch-col label { font-size: 0.82rem; color: #555; font-weight: 500; }
.sasl-batch-col--sm { min-width: 100px; }
.sasl-time-next {
  display: flex; align-items: center; gap: 8px;
}
.sasl-checkbox-next {
  display: flex; align-items: center; gap: 4px;
  font-size: 0.85rem; color: #555; cursor: pointer; white-space: nowrap;
}
.sasl-batch-preview {
  margin: 12px 0 0;
  font-size: 0.85rem;
  color: #2980b9;
  font-weight: 500;
}
.sasl-batch-teacher-hint {
  margin: 12px 0 0;
  font-size: 0.85rem;
  color: #555;
  background: #f0f7ff;
  border: 1px solid #c5dff8;
  border-radius: 6px;
  padding: 8px 12px;
}

/* 舊版時段列（批次表單，保留以免樣式遺留） */
.sasl-slot-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  background: #f8f9fa;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 8px;
}
.sasl-slot-row__fields {
  flex: 1;
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}
.sasl-slot-row__remove {
  background: none;
  border: none;
  color: #e74c3c;
  cursor: pointer;
  font-size: 1rem;
  padding: 4px 6px;
  border-radius: 4px;
  line-height: 1;
  flex-shrink: 0;
  margin-top: 22px;
}
.sasl-slot-row__remove:hover { background: #fdedec; }

.sasl-add-slot-btn { margin-top: 4px; }

/* API 訊息 */
.sasl-api-error {
  background: #fdedec;
  border: 1px solid #f5b7b1;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 0.88rem;
  color: #c0392b;
  line-height: 1.5;
  margin-top: 8px;
}
.sasl-api-success {
  background: #d4edda;
  border: 1px solid #c3e6cb;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 0.88rem;
  color: #155724;
  line-height: 1.5;
  margin-top: 8px;
}

/* 衝突提示框 */
.sasl-conflict-box {
  margin-top: 10px;
  background: #fff8e1;
  border: 1px solid #ffe082;
  border-radius: 8px;
  padding: 12px 14px;
  font-size: 0.87rem;
  color: #5d4037;
}
.sasl-conflict-title {
  font-weight: 600; margin: 0 0 8px;
}
.sasl-conflict-list {
  margin: 0 0 10px; padding-left: 18px;
  line-height: 1.9;
}
.sasl-conflict-cap {
  color: #e65100; font-weight: 500;
}
.sasl-conflict-hint {
  margin: 0;
  font-size: 0.83rem;
  color: #6d4c41;
  line-height: 1.6;
  border-top: 1px solid #ffe082;
  padding-top: 8px;
}

/* 老師快速切換列（無篩選時顯示） */
.sasl-teacher-switch-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  background: #f4f6f9;
  border: 1px solid #dce1e7;
  border-radius: 8px;
  padding: 10px 14px;
  margin-bottom: 16px;
  font-size: 0.88rem;
}
.sasl-teacher-switch-bar__label {
  color: #7f8c8d;
  white-space: nowrap;
  font-size: 0.85rem;
}
.sasl-teacher-switch-bar__pills {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.sasl-teacher-pill {
  background: #fff;
  border: 1px solid #aed6f1;
  border-radius: 20px;
  padding: 5px 14px;
  font-size: 0.83rem;
  color: #2471a3;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
  white-space: nowrap;
}
.sasl-teacher-pill:hover {
  background: #d6eaf8;
  border-color: #85c1e9;
}

/* 老師選擇區（無 filterTeacher 時顯示） */
.sasl-teacher-select {
  margin-top: 16px;
  background: #f0f7ff;
  border: 1px solid #c5dff8;
  border-radius: 10px;
  padding: 14px 16px;
  text-align: left;
  width: 100%;
  box-sizing: border-box;
}
.sasl-teacher-select__label {
  font-size: 0.85rem;
  font-weight: 600;
  color: #2471a3;
  margin: 0 0 10px;
}
.sasl-teacher-select__row {
  display: flex;
  gap: 8px;
  align-items: center;
}
.sasl-teacher-select__row .sasl-input {
  max-width: 240px;
}

@media (max-width: 560px) {
  .sasl-field-row      { grid-template-columns: 1fr; }
  .sasl-modal__footer  { flex-direction: column-reverse; }
  .sasl-modal__footer .sasl-btn { width: 100%; justify-content: center; }
  .sasl-slot-row__fields { flex-direction: column; gap: 8px; }
}

/* ── 新手引導（步驟4）──────────────────────────────── */
.sasl-ob-banner {
  background: linear-gradient(135deg, #eff6ff, #dbeafe);
  border: 1.5px solid #93c5fd;
  border-radius: 10px;
  padding: 14px 18px;
  margin-bottom: 16px;
}
.sasl-ob-banner__steps {
  display: flex; align-items: center; gap: 6px; margin-bottom: 6px; flex-wrap: wrap;
}
.sasl-ob-banner__step { font-size: 0.82rem; color: #93c5fd; font-weight: 600; }
.sasl-ob-banner__step--active { color: #1d4ed8; }
.sasl-ob-banner__sep { color: #bfdbfe; font-size: 0.9rem; }
.sasl-ob-banner__hint { font-size: 0.88rem; color: #1e40af; margin: 0; }
/* 時段管理 tab 導覽引導卡 */
.sasl-ob-guide {
  display: flex; align-items: center; gap: 12px; flex-wrap: wrap;
  background: #fffbeb; border: 1.5px solid #fcd34d;
  border-radius: 10px; padding: 12px 16px; margin-bottom: 16px;
  font-size: 0.9rem; color: #92400e;
}
.sasl-ob-guide--done {
  background: #f0fdf4; border-color: #4ade80; color: #166534;
}
.sasl-ob-guide__btn {
  background: #2563eb; color: #fff; border-radius: 6px;
  padding: 6px 14px; font-size: 0.88rem; font-weight: 600;
  text-decoration: none; white-space: nowrap; transition: background 0.15s;
}
.sasl-ob-guide__btn:hover { background: #1d4ed8; }
/* 手指引導 emoji 動畫 */
.sasl-ob-hand {
  display: inline-block;
  animation: sasl-hand-bounce 0.8s ease-in-out infinite;
  transform-origin: bottom center;
}
@keyframes sasl-hand-bounce {
  0%, 100% { transform: translateY(0); }
  50%       { transform: translateY(-3px); }
}
</style>
